import Axios from 'axios';
import { empresasLead } from './bff/bffClient';
import { mapComercioLead } from './bff/bffMappers';
import { getPathName, getPais, Pais, getApiHash, getApiToken } from './helper';

type ContactoIntegralComercioParams = {
    origen?: string;
    rubro?: string;
    isMobile?: boolean;
    tipoCotizador?: string;
    landingUrl?: string;
    refererUrl?: string;
    nombre?: string;
    apellido?: string;
    codigoArea?: string;
    telefono: {
        prefijo?: string;
        numero?: string;
    }
    provincia: {
        value?: string;
        label?: string;
    }
    localidad: {
        value?: string;
        label?: string;
    }
    email?: string;
    cuit?: string;
    actividad?: string;
    token?: string;
    captchaToken: string;
    parametrosIniciales: {
        origen?: string,
    };
    /** País real del build (lo pasa el form desde config.pais); default getPais(). */
    pais?: Pais;
};

/**
 * Lead Comercio. ROUTING POR PAÍS (el BFF es Argentina-only):
 * - AR: body tipado §12.2 (`mapComercioLead`) al BFF. personType=LEGAL.
 * - UY: flujo LEGACY al monolito (POST {monolito}/SetCotizacionIntegralComercioJSON).
 * El país lo determina `params.pais` o `getPais()`.
 * Devuelve el envelope { data: { api_status, api_data } }.
 */
const guardarContactoIntegralComercio = async (params: ContactoIntegralComercioParams) => {
    const origen = params.parametrosIniciales?.origen ?? params.origen;
    const pais = params.pais ?? getPais();

    if (pais === 'UY') {
        const data: Record<string, any> = {
            hash: await getApiHash(),
            isMobile: "false",
            rubro: "COMERCIO",
            origen: origen,
            landingUrl: params.landingUrl,
            refererUrl: params.refererUrl,
            provincia: params.provincia?.value,
            localidad: params.localidad?.value,
            actividad: params.actividad,
            nombre: params.nombre,
            apellido: params.apellido,
            codigoArea: params.telefono.prefijo ?? null,
            telefono: params.telefono.numero ?? null,
            email: params.email ?? null,
            g_recaptcha_response: params.captchaToken,
        };
        const headers = {
            'content-type': 'application/json',
            "Authorization": 'Bearer ' + await getApiToken(),
        };
        return await Axios.post(await getPathName() + "/SetCotizacionIntegralComercioJSON", data, { headers })
            .then((response) => response)
            .catch((error) => error);
    }

    const body = mapComercioLead({
        origen,
        landingUrl: params.landingUrl ?? (typeof window !== 'undefined' ? window.location.href : undefined),
        refererUrl: params.refererUrl,
        provincia: params.provincia?.value,
        localidad: params.localidad?.value,
        actividad: params.actividad,
        nombre: params.nombre,
        apellido: params.apellido,
        codigoArea: params.telefono.prefijo,
        telefono: params.telefono.numero,
        email: params.email,
        cuit: params.cuit,
    });

    try {
        const apiData = await empresasLead(body);
        return { data: { api_status: 200, api_data: apiData } };
    } catch (error) {
        return error;
    }
};

export default guardarContactoIntegralComercio;
